/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddressBase } from '../../models/address-base';
import { AddressValidationResponse } from '../../models/address-validation-response';

export interface ValidateUsAddress$Params {
      body: AddressBase
}

export function validateUsAddress(http: HttpClient, rootUrl: string, params: ValidateUsAddress$Params, context?: HttpContext): Observable<StrictHttpResponse<AddressValidationResponse>> {
  const rb = new RequestBuilder(rootUrl, validateUsAddress.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AddressValidationResponse>;
    })
  );
}

validateUsAddress.PATH = '/address-validation/validate-us';
